(function () {
  'use strict';

  document.querySelectorAll('.ccv3-faq__d').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      var list = item.closest('.ccv3-faq__list');
      if (!list || list.dataset.singleOpen !== 'true') return;
      list.querySelectorAll('.ccv3-faq__d[open]').forEach(function (other) {
        if (other !== item) other.open = false;
      });
    });
  });
})();
